export default {
  originCity: 'Seleciona a cidade de partida',
  destinationCity: 'Selecione a cidade de chegada',
  direct: 'Direto',
  indirect: '1 ou mais escalas',
  getPrices: 'Obter preços',
  directAvailable: 'Direto disponível desde',
}
